import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/form-title.module.css';

function FormTitleTypography({ className = null, ...props }: TypographyProps) {
    return <Typography className={classNames([styles.container, className])} {...props} />;
}

export default FormTitleTypography;
